import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVoiceLow"><Path d="M9 18H7V6H9V18Z" fill="currentColor"/><Path d="M17 16H15V8H17V16Z" fill="currentColor"/><Path d="M13 14H11V10H13V14Z" fill="currentColor"/><Path d="M5 13.5H3V10.5H5V13.5Z" fill="currentColor"/><Path d="M21 13.5H19V10.5H21V13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceLow;
